import { combineReducers } from 'redux';

import incomingFaxes from './Faxes/incomingFaxes';
import outgoingFaxes from './Faxes/outgoingFaxes';
import relay from './Faxes/relayFaxes';
import faxesSummary from './Faxes/faxesSummary';
import faxesFailureSummary from './Faxes/faxesFailureSummary';

export default combineReducers({
    incomingFaxes,
    relay,
    outgoingFaxes,
    faxesSummary,
    faxesFailureSummary
});